export enum SkyMediaBreakpoints {
  xs =  1,
  sm,
  md,
  lg
}
